import React from 'react';
import {
  Button, SimpleForm, DateInput, AutocompleteArrayInput, SelectArrayInput, SelectInput, ReferenceArrayInput, Toolbar, useNotify,
  TextField, Datagrid, Edit, Create, List, DateField, Filter, TextInput, SaveButton, required, FormDataConsumer
} from 'react-admin';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import CloudDownload from '@material-ui/icons/CloudDownload';
import CircularProgress from '@material-ui/core/CircularProgress';
import DataTable from 'react-data-table-component';
import { fetchUtils } from 'react-admin';
import { DisclaimerComponent } from './components/disclaimer.js';

import { ExpandMore } from '@material-ui/icons';
import { Accordion, AccordionSummary, AccordionDetails, Box, Card } from '@material-ui/core';
import FilterCardTitle from './common/filters/FilterCardTitle';

const choicesSizes = require('./components/sizes.json');
const choicesDevices = require('./components/devices.json');
const countryChoices = require('./components/countries.json');
const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');
const fetch = fetchUtils.fetchJson;

const BASE_URL = window.nobid_endpoint + '/advertiser_cpm_report';
const requestOptions = { headers: new Headers() };
requestOptions.headers.set('accept', 'application/json');
const token = localStorage.getItem('token');
requestOptions.headers.set('Authorization', `Bearer ${token}`);

function downloadCSV (array) {
  array.forEach((row, i) => {
    delete array[i].id;
    delete array[i].code;
  });
  dataSupport.exportData(array);
}

const choicesInterval = [
  { id: 'day', name: 'Daily' },
  { id: 'week', name: 'Weekly' },
  { id: 'month', name: 'Monthly' },
  { id: 'year', name: 'Yearly' }
];

const dateRangeChoices = [
  { id: '0', name: 'Today' },
  { id: 1, name: 'Yesterday' },
  { id: 2, name: 'Last 2 Days' },
  { id: 3, name: 'Last 3 Days' },
  { id: 5, name: 'Last 5 Days' },
  { id: 7, name: 'Last 7 Days' },
  { id: 8, name: 'Last 8 Days' },
  { id: 10, name: 'Last 10 Days' },
  { id: 15, name: 'Last 15 Days' },
  { id: 30, name: 'Last 30 Days' },
  { id: 'lm', name: 'Last Month' },
  { id: 'mtd', name: 'Month to Date' },
  { id: 'mty', name: 'Month to Yesterday' },
  { id: 'ytd', name: 'Year to Date' },
  { id: 'yty', name: 'Year to Yesterday' },
  { id: 'custom', name: 'Custom' }
];

const choicesShow = [
  { id: 'tldomain', name: 'Domain' },
  { id: 'country', name: 'Country' },
  { id: 'device', name: 'Device' },
  { id: 'adsize', name: 'Ad Size' }
];

const BASE_COLUMNS = [
  { name: 'Date', selector: 'date', sortable: true, cell: row => row.date },
  { name: 'Domain', selector: 'tldomain', sortable: true },
  { name: 'Country', selector: 'country', sortable: true },
  { name: 'Device', selector: 'device', sortable: true },
  { name: 'Ad Size', selector: 'adsize', sortable: true },
  { name: 'Advertiser', selector: 'advertiser', sortable: true, cell: row => row.advertiser_name || row.advertiser_id },
  { name: '$Your CPM', selector: 'avg_cpm', sortable: true, cell: row => <span>{utils.formatDouble(row.avg_cpm)}</span>, definition: 'Your Average CPM defined as 1,000 * Revenue / Impressions in US Dollars ($).' },
  { name: '$Market CPM', selector: 'avg_cpm_nobid', sortable: true, cell: row => <span>{utils.formatDouble(row.avg_cpm_nobid)}</span>, definition: 'Market Average CPM from other bidders, defined as 1,000 * Revenue / Impressions in US Dollars ($).' }
];

let defaultColumnSelectors = ['date', 'avg_cpm', 'avg_cpm_nobid'];

let formData = {};
function setFormData (formdata) {
  formData = formdata;
}

class CustomToolbar extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params: ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL
  };

  constructor (props) {
    super(props);
    this.parent = props.parent;
  }

  fetchData = () => {
    function updateState (that, headers, json) {
      if (json) {
        for (let i in json) {
          let r = json[i];
          if (r.date) r.date = r.date.substring(0, r.date.indexOf('T'));
        }
      }

      const showList = formData.show || [];
      const columnSelectors = defaultColumnSelectors.concat(showList);
      that.parent.setState({
        data: json,
        saved_data: json,
        columns: BASE_COLUMNS.filter(c => columnSelectors.includes(c.selector)),
        loading: false
      });
    }

    formData.show = formData.show || [];
    let show = '';
    if (formData.show) formData.show.forEach(item => { show += '&show=' + item; });

    let url = `${this.state.baseUrl}?${show}${utils.formDataFieldsQueryStringFormat(
      formData,
      ['interval', 'date_range', 'start_date', 'end_date', 'advertiser_id', 'country', 'device', 'adsize']
    )}`;

    this.parent.setState({ loading: true });
    const requestOptions = { headers: new Headers() };
    requestOptions.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    requestOptions.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, requestOptions).then(({ headers, json }) => {
      updateState(this, headers, json);
    });
  };

  handleClick = () => {
    this.fetchData();
  };

  render () {
    return (
      <Toolbar>
        <SaveButton style={{ marginRight: '25px' }} variant='contained'
          color='primary' disabled={this.parent.state.loading} {...this.props} />
        <Button label="Run Report" onClick={this.handleClick} props={this.props} variant="contained"
          style={{ marginRight: '25px', padding: '7px', width: '160px' }} color="primary" startIcon={<RunReportIcon />} disabled={this.parent.state.loading} />
      </Toolbar>
    );
  }
}

const CpmReportTitle = ({ record }) => {
  return <span>CPM Comparison {record ? `"${record.name}"` : ''}</span>;
};

const CpmReportFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search_name" alwaysOn resettable />
  </Filter>
);

export const AdvertiserCpmReportList = ({ permissions, ...props }) => (
  <List {...props} title="CPM Comparison Reports" perPage={25} bulkActionButtons={false} filters={<CpmReportFilters />}
    exporter={false}>
    <Datagrid rowClick="edit">
      <TextField source="name" label="Name" />
      <DateField source="updated_at" label="Update Date" />
      <DateField source="created_at" label="Creation Date" />
      <DeleteWithConfirmation {...props} />
    </Datagrid>
  </List>
);

class CpmReportComponent extends React.Component {
  state = {
    data: [],
    saved_data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params: ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL,
    columns: BASE_COLUMNS,
    dateRange: this.props.record.date_range
  };

  render () {
    const { loading, data, dateRange } = this.state;
    const { permissions, formType, record } = this.props;
    const isAdmin = permissions && (permissions.role === 'admin' || permissions.role === 'report_admin');
    if (isAdmin && choicesShow.findIndex(c => c.id === 'advertiser') === -1) {
      choicesShow.push({ id: 'advertiser', name: 'Advertiser' });
    }

    return (
      <div>
        <Card>
          <SimpleForm toolbar={<CustomToolbar parent={this} />} style={{ width: '100%', backgroundColor: 'inherit', borderRadius: '5px' }} {...this.props}>
            <TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
            <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper2">
              <FormDataConsumer>
                {({ formData }) => setFormData(formData)}
              </FormDataConsumer>
              <SelectInput label="Interval" source="interval" choices={choicesInterval} defaultValue='day'
                disabled={loading} />
              <div>
                <SelectInput label="Date Range" source="date_range"
                  onChange={value => this.setState({ dateRange: value.target.value })}
                  choices={dateRangeChoices}
                  defaultValue="8"
                  disabled={loading} />
                <div style={{ float: 'right', paddingLeft: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                  <div style={{ float: 'left', paddingRight: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                    <DateInput label="Start Date" source="start_date" allowEmpty disabled={loading}
                      style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                  </div>
                  <div style={{ float: 'left', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                    <DateInput label="End Date" source="end_date" allowEmpty disabled={loading}
                      style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                  </div>
                </div>
              </div>
              <SelectArrayInput label="Show"
                size="small"
                source="show"
                choices={choicesShow}
                style={{ width: '400px', flexGrow: 1 }}
                disabled={loading} />
            </div>

            <Accordion defaultExpanded={formType === 'create'} style={{ marginBottom: '20px' }} fullWidth>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <FilterCardTitle title="Filters" />
              </AccordionSummary>
              <AccordionDetails>
                <Box style={{ width: '100%' }}>
                  {isAdmin &&
                    <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }}>
                      <div style={{ flex: 1 }}>
                        <ReferenceArrayInput
                          source="advertiser_id"
                          label="Advertisers"
                          reference="advertisers"
                          basePath="advertisers"
                          perPage={15}
                          sort={{ field: 'name', order: 'ASC' }}
                          filterToQuery={searchText => ({ search_name: searchText })}
                          allowEmpty
                          disabled={loading}
                          fullWidth>
                          <AutocompleteArrayInput disabled={loading}
                            optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''}
                            optionValue="code" />
                        </ReferenceArrayInput>
                      </div>
                    </div>
                  }
                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }}>
                    <div style={{ flex: 1 }}>
                      <SelectArrayInput label="Devices"
                        source="device"
                        choices={choicesDevices}
                        disabled={loading}
                        fullWidth />
                    </div>
                    <div style={{ flex: 1 }}>
                      <SelectArrayInput label="Ad Sizes"
                        source="adsize"
                        choices={choicesSizes}
                        disabled={loading}
                        fullWidth />
                    </div>
                    <div style={{ flex: 1 }}>
                      <SelectArrayInput label="Countries"
                        source="country"
                        choices={countryChoices}
                        disabled={loading}
                        fullWidth />
                    </div>
                  </div>
                </Box>
              </AccordionDetails>
            </Accordion>
          </SimpleForm>
        </Card>
        <div style={{ height: '15px', backgroundColor: 'transparent' }} />
        <Card>
          <DataTable
            title="CPM Comparison Report"
            theme={window.nobid_table_theme()}
            columns={this.state.columns}
            data={data}
            progressPending={loading}
            pagination
            fixedHeader
            paginationPerPage={30}
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            dense
            highlightOnHover
            subHeader={!loading}
            subHeaderComponent={
              (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input type="text" id='search_box' label="Search"
                    variant="outlined"
                    style={{ margin: '5px' }}
                    onChange={(target) => dataSupport.filterData(this)} />
                  <CloudDownload
                    label="Export"
                    style={{ margin: '5px' }}
                    color="action"
                    onClick={() => downloadCSV(this.state.data)}
                  />
                </div>
              )
            }
          />
          <DisclaimerComponent />
        </Card>
      </div>
    );
  }
}

export const AdvertiserCpmReportEdit = (props) => (
  <Edit title={<CpmReportTitle />} {...props}>
    <CpmReportComponent formType="edit" permissions={props.permissions} {...props} />
  </Edit>
);

export const AdvertiserCpmReportCreate = (props) => (
  <Create title="Create CPM Comparison Report" {...props}>
    <CpmReportComponent formType="create" permissions={props.permissions} {...props} />
  </Create>
);
